import clsx from "clsx";
import React, { FC, useState } from "react";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "@pd/pd-ui-kit";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import ProofDocumentControl from "~/components/Forms/ViolationRecordingForm/ProofDocumentControl";
import { useGetLocationData, useSetLocationData } from "~/hooks/locationData";
import { uploadFile } from "~/libs/uploadFile";
import { useUploadGibddMutation } from "~/schemas/generated/graphql";
import { useNotify } from "~/shared/hooks/useNotify";
import { Field } from "~/shared/ui/Field";

import s from "./UploadForm.less";

interface IProps {
  setCloseModal: () => void;
  // refetch;
}

const GIBDDUploadFileForm: FC<IProps> = ({ setCloseModal }) => {
  const { t } = useTranslation();
  const setData = useSetLocationData();
  const { fileId } = useGetLocationData();
  const { notifySuccess, notifyError } = useNotify();
  const [uploadFileCatalog, FileUpload] = useUploadGibddMutation({
    onCompleted() {
      // refetch();

      notifySuccess(t("common.data_uploaded_successfully"));
      setCloseModal();
    },
    onError() {
      setCloseModal();
    },
  });

  const [uploadFileLoader, setUploadFileLoader] = useState(false);

  const schema = yup.object().shape({});

  const { handleSubmit, control, errors } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = () => {
    // console.log("SSSSSSSSSS");
    uploadFileCatalog({
      variables: {
        fileId: fileId,
      },
    });
  };

  return (
    <form className={s.upl_form} onSubmit={handleSubmit(onSubmit)}>
      <ul className={s.list}>
        <li>
          <div className={clsx(s.inputWrapper, s.align_label, s.align_error)}>
            <label>{t("srr.uplouad")}</label>
            {!!fileId ? (
              <div className={s.fileViewer}>
                <ProofDocumentControl id={fileId} />
              </div>
            ) : (
              <Field
                type="file"
                name="file"
                control={control}
                error={errors["file"]?.message}
                accept={["text/csv", "application/vnd.ms-excel"]}
                loading={uploadFileLoader}
                className={s.fileField}
                onUpload={async (file) => {
                  setUploadFileLoader(true);
                  try {
                    const uploaded = await uploadFile(file, () =>
                      notifyError(t("common.data_uploaded_error")),
                    );
                    if (uploaded) {
                      // fileId хранится в location state (не в RHF), поэтому
                      // onUpload ничего не возвращает: после загрузки поле
                      // подменяется ProofDocumentControl, удаление — через него.
                      setData("fileId", uploaded.id);
                      notifySuccess(t("common.file_uploaded_successfully"));
                    }
                  } finally {
                    setUploadFileLoader(false);
                  }
                }}
              />
            )}
          </div>
        </li>

        <li
          className={clsx(s.text_drop, {
            // [s.text_drop_file]: !isDisable,
          })}
        />
        <li className={s.with_btn}>
          <Button
            size={"middle"}
            htmlType="submit"
            loading={FileUpload.loading || uploadFileLoader}
            // disabled={!isDisable}
          >
            {t("ui.uploadBase")}
          </Button>
        </li>
      </ul>
    </form>
  );
};
export default GIBDDUploadFileForm;
